import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Autoplay,
    EffectCreative,
} from 'swiper/modules';

document.addEventListener(
    'DOMContentLoaded',
    () => {
        Swiper.use([Navigation, Pagination, Autoplay, EffectCreative]);
        const sliders = document.querySelectorAll('.js-slider-main');
        sliders.forEach((slider) => {
            const swiperSlder = new Swiper(slider, {
                slidesPerView: 'auto',
                speed: 1000,
                loop: true,
                grabCursor: true,
                effect: 'creative',
                creativeEffect: {
                    prev: {
                        scale: 1,
                    },
                    next: {
                        scale: 0.99999,
                    },
                },
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true,
                },
            });

            let p = 0;
            swiperSlder.on('progress', function (swiper, progress) {
                slider.setAttribute('data-progress', String(progress > p));
                p = progress;
            });
        });
    },
    { once: true },
);
